import React from 'react';
import type { UploadErrorInfo } from '../utils/uploadErrors';

interface UploadErrorModalProps {
  error: UploadErrorInfo | null;
  onClose: () => void;
}

const KIND_LABELS: Record<UploadErrorInfo['kind'], string> = {
  invalid_format: 'Invalid file format',
  server_error: 'Server unavailable',
  firebase_error: 'Firebase error',
  auth_error: 'Sign-in required',
  unknown: 'Unexpected error',
};

const UploadErrorModal: React.FC<UploadErrorModalProps> = ({ error, onClose }) => {
  if (!error) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 p-4"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.92)' }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#000000',
          border: '2px solid #e74c3c',
          borderRadius: 0,
          maxWidth: '32rem',
          width: '100%',
          padding: '2rem',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
          <div
            style={{
              width: '3rem',
              height: '3rem',
              margin: '0 auto 1rem',
              color: '#e74c3c',
            }}
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2
            style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              color: '#ffffff',
              marginBottom: '0.5rem',
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}
          >
            {error.title}
          </h2>
          <p
            style={{
              color: 'rgba(255, 255, 255, 0.85)',
              fontSize: '0.9rem',
              fontFamily: "'Inter', sans-serif",
              lineHeight: 1.5,
              marginBottom: '1rem',
            }}
          >
            {error.message}
          </p>
          <span
            style={{
              display: 'inline-block',
              border: '1px solid #e74c3c',
              color: '#e74c3c',
              padding: '0.35rem 0.75rem',
              fontSize: '0.75rem',
              fontWeight: 600,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              fontFamily: "'Inter', sans-serif",
            }}
          >
            {KIND_LABELS[error.kind]}
          </span>
        </div>

        {error.details && (
          <div
            style={{
              backgroundColor: 'rgba(231, 76, 60, 0.1)',
              border: '1px solid rgba(231, 76, 60, 0.4)',
              borderRadius: 0,
              padding: '0.875rem',
              marginBottom: '1.25rem',
            }}
          >
            <p
              style={{
                color: '#ffffff',
                fontSize: '0.875rem',
                fontFamily: "'Inter', sans-serif",
                lineHeight: 1.5,
                margin: 0,
              }}
            >
              {error.details}
            </p>
          </div>
        )}

        <button
          type="button"
          onClick={onClose}
          style={{
            width: '100%',
            background: '#ffffff',
            border: '1px solid #ffffff',
            color: '#000000',
            padding: '0.75rem 1rem',
            fontSize: '0.85rem',
            fontWeight: 600,
            letterSpacing: '0.05em',
            cursor: 'pointer',
            fontFamily: "'Inter', sans-serif",
            borderRadius: 0,
            textTransform: 'uppercase',
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default UploadErrorModal;
